<template>
    <a class="connect flex-center" href="https://www.linkedin.com/in/mike-ross-9219bb72/" target="_blank">
        <span>Connect</span>
        <img class="p-desktop" src="@/assets/Images/IconLinkedIn.png" alt="Icon - LinkedIn" title="LinkedIn" width="40" height="40"/>
        <img class="p-mobile right" src="@/assets/Images/IconLinkedIn.png" alt="Icon - LinkedIn" title="LinkedIn" width="30" height="30"/>
    </a>
    <a class="connect flex-center" :href="resumeURL" target="_blank">
        <span>Resume</span>
        <img class="p-desktop" src="@/assets/Images/IconExperience.png" alt="Icon - Resume" title="Resume" width="40" height="40"/>
        <img class="p-mobile right" src="@/assets/Images/IconExperience.png" alt="Icon - Resume" title="Resume" width="30" height="30"/>
    </a>
</template>

<script>
export default {
    name: "SocialConnect",
    data: () => ({ resumeURL: "/Documents/Resume - Mike Ross.pdf?v=2" })
};
</script>